<div [class.has-error]="showError && !!formControl.errors" class="form-group {{ props.fieldGroupClassName }}">
  <label *ngIf="props.label && props.hideLabel !== true" [className]="props.labelClassName" [for]="id">
    <span [innerHTML]="props.label"></span>
    <span *ngIf="props.required && !props.hideRequiredMarker" class="required-marker">
      {{ props.requiredMarker || "*" }}
    </span>
    <span *ngIf="!props.required && !props.hideOptionalMarker" class="optional-marker">
      {{ props.optionalMarker || "(optional)" | translate }}
    </span>

    <ng-container *ngIf="!!props.descriptionUnderLabel">
      <ng-container [ngTemplateOutlet]="description"></ng-container>
    </ng-container>
  </label>

  <ng-container *ngIf="!!props.errorUnderLabel">
    <ng-container [ngTemplateOutlet]="error"></ng-container>
  </ng-container>

  <ng-template #fieldComponent></ng-template>

  <ng-container *ngIf="!props.errorUnderLabel">
    <ng-container [ngTemplateOutlet]="error"></ng-container>
  </ng-container>

  <ng-container *ngIf="!!field['messages']">
    <ng-container *ngFor="let message of field['messages']">
      <div class="alert alert-{{ message.level.toLowerCase() }} {{ message.level.toLowerCase() }}-feedback">
        <ng-container *ngIf="message.text">
          <span [innerHTML]="message.text"></span>
        </ng-container>

        <ng-container
          *ngIf="message.template"
          [ngTemplateOutlet]="message.template"
          [ngTemplateOutletContext]="{ data: message.data }"
        >
        </ng-container>

        <button *ngIf="message.dismissible" (click)="closeMessage(message)" class="close">&times;</button>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!props.descriptionUnderLabel">
    <ng-container [ngTemplateOutlet]="description"></ng-container>
  </ng-container>
</div>

<ng-template #description>
  <small *ngIf="props.description" [innerHTML]="props.description" class="form-text text-muted"> </small>
</ng-template>

<ng-template #error>
  <div *ngIf="showError" [class.mb-2]="props.errorUnderLabel" [style.display]="'block'" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
</ng-template>
